import { createFileRoute } from '@tanstack/react-router';
import { PreciosPage } from '@/components/marketing/PreciosPage';
import { MarketingShell } from '@/components/marketing/MarketingShell';

/**
 * `/precios` — catálogo por productos comerciales (Monotributo, RI, Estudio Contable y API) + toggle mensual/anual + FAQ.
 */
export const Route = createFileRoute('/_public/precios')({
  component: PreciosRoute,
});

function PreciosRoute(): JSX.Element {
  return (
    <MarketingShell currentPath="/precios">
      <PreciosPage />
    </MarketingShell>
  );
}
